// extracted by mini-css-extract-plugin
module.exports = {"textInfo":"FooterTextInfo_textInfo__Hxit9 small"};